import styled from "styled-components";

export const FooterWrapper = styled.div`
  height: 5vh;
  width: 100%;
  border-top: 2px solid #0031ad;
  display: flex;
  justify-content: space-around;
`;
